import '@/types';

export default class Article implements IArticle {
    public name: string = '';
    public description: string = '';
    public measuringUnit: string = '';
    public materials: IArticleUsedMaterial[] = [];
    public labourCosts: IArticleLabourCost[] = [];
    public salesPrices: IArticleSalesPrice[] = [];
    public variants: IArticleVariant[] = [];
    public id: string = '';
    public allowedWorktypes: string[] = [];
    public logs: ILog[] = [];
    public status: number = 0;
    public type: number = 0;
    public billOfMaterials: IArticleBillOfMaterialLine[] = [];

    public calculateMissingParameters(projecttypes: string[], margin = 40) {
        projecttypes.forEach((projecttype) => {
            // fill in missing labour costs
            if (!this.labourCosts.some((labourCost) => {
                return labourCost.type === projecttype;
            })) {
                this.labourCosts.push({type: projecttype, cost: 0, costTarget: 0, averageCost: 0, averageDuration: 0});
            }

            // fill missing sales prices
            if (!this.salesPrices.some((salesPrice) => {
                return salesPrice.type === projecttype;
            })) {
                this.salesPrices.push({
                    type: projecttype,
                    margin,
                    cost: 0,
                    price: 0,
                    autoUpdate: false,
                    profit: 0,
                });
            }

            // fill missing sales prices
            this.variants.forEach((variant) => {
                if (!variant.salesPrices.some((salesPrice) => {
                    return salesPrice.type === projecttype;
                })) {
                    variant.salesPrices.push({
                        type: projecttype,
                        margin,
                        cost: 0,
                        price: 0,
                        autoUpdate: false,
                        profit: 0,
                    });
                }
            });
        });
    }
}
